import { render, staticRenderFns } from "./OtpVerify.vue?vue&type=template&id=26356d30&"
import script from "./OtpVerify.vue?vue&type=script&lang=js&"
export * from "./OtpVerify.vue?vue&type=script&lang=js&"
import style0 from "./OtpVerify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports